import Vue from 'vue';
import {
  Switch,
  Icon,
  Skeleton,
  Tag,
  List,
  TreeSelect,
  Empty,
  Col, 
  Row,
  Popup,
  DropdownMenu, 
  DropdownItem,
  PullRefresh,
  Sticky,
  Circle,
  Progress,
  Dialog,
  Toast,
  Checkbox,
  Uploader
} from 'vant'

Vue.use(Switch)
    .use(Icon)
    .use(Skeleton)
    .use(Tag)
    .use(List)
    .use(TreeSelect)
    .use(Empty)
    .use(Col)
    .use(Row)
    .use(Popup)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(PullRefresh)
    .use(Sticky)
    .use(Circle)
    .use(Progress)
    .use(Dialog)
    .use(Toast)
    .use(Checkbox)
    .use(Uploader)